import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function InsightsIndex() {
  const [posts, setPosts] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  useEffect(() => {
    const params = {};
    if (q) params.search = q;
    if (cat) params.category = cat;
    api.get("/blog", { params }).then((r) => setPosts(r.data));
  }, [q, cat]);

  const categories = ["Mutual Funds", "Corporate Advisory", "Tax Planning", "Markets", "Planning"];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline text-gold-dark mb-6">Insights</div>
      <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight mb-10">Notes from the desk.</h1>

      <div className="flex flex-wrap gap-4 mb-10">
        <input data-testid="blog-search" placeholder="Search notes…" value={q} onChange={(e)=>setQ(e.target.value)} className="flex-1 min-w-[220px] px-5 py-3 rounded-full border border-midnight/15 bg-white text-sm focus:border-gold outline-none" />
        <select data-testid="blog-category" value={cat} onChange={(e)=>setCat(e.target.value)} className="px-5 py-3 rounded-full border border-midnight/15 bg-white text-sm">
          <option value="">All categories</option>
          {categories.map((c)=><option key={c}>{c}</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.id} to={`/insights/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="bg-white rounded-2xl overflow-hidden border border-black/5 hover:border-gold/40 group">
            {p.cover_image && <div className="aspect-[16/10] overflow-hidden"><img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
            <div className="p-6">
              <div className="overline text-gold-dark mb-3">{p.category}</div>
              <h3 className="font-display text-xl text-midnight mb-3">{p.title}</h3>
              <p className="text-sm text-midnight/70 leading-relaxed line-clamp-3">{p.excerpt}</p>
              <div className="mt-4 text-xs text-midnight/50">{p.author} · {new Date(p.created_at).toLocaleDateString()}</div>
            </div>
          </Link>
        ))}
        {posts.length === 0 && <p className="text-midnight/50">No posts yet.</p>}
      </div>
    </div>
  );
}

export function InsightDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then((r)=>setPost(r.data)).catch(()=>setErr(true)); }, [slug]);
  if (err) return <div className="p-20 text-center text-midnight/60">Post not found. <Link className="underline" to="/insights">Back</Link></div>;
  if (!post) return <div className="p-20 text-center">Loading…</div>;
  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
      <Link to="/insights" className="text-sm text-midnight/60 hover:text-midnight">← All insights</Link>
      <div className="overline text-gold-dark mt-8 mb-3">{post.category}</div>
      <h1 className="font-display text-4xl md:text-5xl text-midnight tracking-tight leading-tight">{post.title}</h1>
      <div className="mt-4 text-sm text-midnight/60">{post.author} · {new Date(post.created_at).toLocaleDateString()}</div>
      {post.cover_image && <div className="mt-10 rounded-2xl overflow-hidden aspect-[16/9]"><img src={post.cover_image} alt="" className="w-full h-full object-cover" /></div>}
      <div className="mt-10 prose max-w-none text-midnight/85 leading-relaxed [&>p]:mb-6" dangerouslySetInnerHTML={{ __html: post.content }} />
    </article>
  );
}
